/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Info } from 'react-feather';

import Select from 'react-select';
import { classNames } from '../util/functions';

const ReactSelect = ({
  label,
  items,
  name,
  isMultiSelect,
  errorText,
  value,
  onChange,
  customContainerStyles,
  required,
  disabled,
}) => {
  console.log("🚀 ~ ReactSelect ~ value:", value)
  const { t } = useTranslation();
  const [selectedValue, setSelectedValue] = useState(
    isMultiSelect ? [] : null,
  );
  const [menuPortalTarget, setMenuPortalTarget] = useState(null);

  useEffect(() => {
    setMenuPortalTarget(document.body);
  }, []);

  useEffect(() => {
    if (Array.isArray(value) && value?.length) {
      setSelectedValue(
        value.map((item) => ({ label: t(item), value: t(item) })),
      );
      return;
    }
    if (typeof value === 'string' && value.length) {
      setSelectedValue({ label: t(value), value: t(value) });
      return;
    }
    setSelectedValue(isMultiSelect ? [] : null);
  }, [isMultiSelect, t, value]);

  const _handleChange = (selectedItem) => {
    if (isMultiSelect) {
      onChange(selectedItem?.map((item) => item.value) ?? []);
    } else {
      onChange(selectedItem?.value);
    }
    setSelectedValue(selectedItem);
  };
  return (
    <div
      className={classNames(`w-full
      ${customContainerStyles}`)}
    >
      {label && (
        <div className='flex justify-between mb-1 ml-2'>
          <label className='block text-lg font-medium text-white'>
            {label}{' '}
            {required && (
              <span className='text-red-500'>*{t('common.required')}</span>
            )}
          </label>
        </div>
      )}
      <Select
        value={selectedValue}
        options={items.map((item) => ({ label: t(item), value: t(item) }))}
        isMulti={isMultiSelect}
        isSearchable={false}
        onChange={_handleChange}
        name={name}
        isDisabled={disabled}
        menuPortalTarget={menuPortalTarget}
        menuPosition={menuPortalTarget ? 'fixed' : 'absolute'}
        menuPlacement='auto'
        maxMenuHeight={220}
        menuShouldScrollIntoView={false}
        styles={customStyles}
      />
      {!!errorText && (
        <div className='flex items-center space-x-1 mt-2'>
          <Info color='#dc2626' size={20} />
          <p className='text-md font-medium  py-white text-red-500'>
            {errorText}
          </p>
        </div>
      )}
    </div>
  );
};
const customStyles = {
  control: (base, state) => ({
    ...base,
    backgroundImage: 'linear-gradient(to bottom, rgba(128,128,128,0.9), black)',
    backgroundColor: 'lightWhite',
    borderRadius: '20px',
    padding: '2px',
    borderColor: state.isFocused ? '#dc2626 !important' : '#fff !important',
    boxShadow: '0 !important',
    '&:hover': {
      borderColor: '#ffff !important',
      outline: 'none',
    },
  }),
  singleValue: (provided) => ({
    ...provided,
    color: '#fff',
  }),
  menu: (provided) => ({ ...provided, zIndex: 99999 }),
  menuPortal: (provided) => ({ ...provided, zIndex: 99999 }),
  menuList: (provided) => ({
    ...provided,
    maxHeight: 220,
  }),
};
export default ReactSelect;
